import React, { useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";

function Attendance() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    
    },
    {
      header: "Reference No",
      accessorKey: "ReferenceNo"
    },
    {
      header: "Date",
      accessorKey: "Date",
    },
    {
      header: "Employee",
      accessorKey: "Employee",
    },
    {
      header: "In Time",
      accessorKey: "InTime",
    },
    {
      header: "Out Time",
      accessorKey: "OutTime",
    },
    {
      header: "Update Time",
      accessorKey: "UpdateTime",
    },
    {
      header: "Time Count",
      accessorKey: "TimeCount",
    },
    {
      header: "Note",
      accessorKey: "Note",
    },
   
    {
      header: "Added By",
      accessorKey: "AddedBy",
    },
    {
      header: "Actions",
      accessorKey: "total",
      cell: (row) => <Dropdown />,
    },

  ]);
  const [data] = useState([

  
  ]);
  const [buttonData] = useState([   
    {
      buttonText: "Add Attendance",
      path: "addAttendanceForm"
    },
    
  ]);
 
  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={"Attendances"}
        buttonData={buttonData}
      

      />
    </main>
  );
}

export default Attendance;
